module.exports = __webpack_public_path__ + "img/ten.a35ab72.svg";